import {
    Accordion, AccordionItem, AccordionButton, AccordionPanel, AccordionIcon, Box, Text,
} from "@chakra-ui/react";
import WebSiteSetting from "./webSiteSetting";

const SettingsPage = () => {
    return (
        <Box mx="auto" mt={4}>
            <Accordion allowToggle defaultIndex={[0]}>
                <AccordionItem border="1px solid #E2E8F0" borderRadius="8px" mb={4}>
                    <h2>
                        <AccordionButton _expanded={{ bg: "#006838", color: "white" }} borderRadius="8px" py={4} >
                            <Box flex="1" textAlign="left">
                                <Text className="font-poppins text_semibold text_lg">
                                    Emails Setting
                                </Text>
                            </Box>
                            <AccordionIcon />
                        </AccordionButton>
                    </h2>
                    <AccordionPanel pb={4}>
                        <WebSiteSetting />
                    </AccordionPanel>
                </AccordionItem>
            </Accordion>
        </Box>
    );
};

export default SettingsPage;